import { AddRequestComponent } from './add-requesst/add-request.component';
import { EditRequestComponent } from './edit-request/edit-request.component';
import { ViewRequestComponent } from './view-request/view-request.component';
import { RequestListComponent } from './view-request/request-list/request-list.component';
import { SingleRequestViewComponent } from './view-request/single-request-view/single-request-view.component';
import { RequestResponseViewComponent } from './view-request/request-response-view/request-response-view.component';

export const RequestRouting = [
    {   path: '', redirectTo: 'list-request', pathMatch: 'full' },
    {   path: 'add-request/:requestType', component: AddRequestComponent},
    {   path: 'add-request', component: AddRequestComponent},
    {   path: 'list-request', 
        children: [
            { path: '' , component: ViewRequestComponent, },
            { path: ':requestType', component: RequestListComponent },
            { path: ':requestType/:ID', component: SingleRequestViewComponent},
        ]
    },
    {   path: 'response-view/:requestType/:requestID/:appRequestID', component: RequestResponseViewComponent},
    {   path: 'edit-request/:type/:ID', component: EditRequestComponent},
];


// export const RequestRoutingBreadcrumb = [
//     // { name: 'Create', path: '/add-request' },
//     // { name: 'Edit', path: '/edit-request' },
//     // { name: 'List Request', path:'/list-request', 
//     //   children: [
//     //     { name:'Custom Request', path: '/custom-request'},
//     //     { name:'Leave Request', path: '/leave-request'},
//     //     { name:'Location Request', path: '/location-request'},
//     //     { name:'Route Change', path: '/route-change'},
//     //     { name:'Shift Change', path: '/shift-change'},
//     //     { name:'Time Change', path: '/time-change'},
//     //     { name:'On Board Request', path: '/on-board-request'},
//     ]
//     }   
// ];
